import React from "react";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorScreenProps,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

import { RouteProp } from "@react-navigation/native";
import { HeaderButton } from "../../components";

import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";

import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { TeamScheduleHistoryListScreen } from "./TeamScheduleHistoryListScreen";
import { TeamScheduleHistoryScreenCombined } from "./TeamScheduleHistoryScreenCombined";
import { Stack, ParamList } from "./TeamScheduleHistoryStack";
import { TeamScheduleHistoryDetail } from "./TeamScheduleHistoryDetail";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";

export const TeamScheduleHistoryStack = (
  props: UserLoggedInNavigatorScreenProps<"TeamScheduleHistory">
) => {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const intlTokens = useIntlTokens();

  return (
    <Stack.Navigator key={isCompact + ""}>
      {isCompact ? (
        <Stack.Group>
          <Stack.Screen
            name="TeamScheduleHistoryScreenList"
            component={TeamScheduleHistoryListScreen}
            initialParams={props.route.params}
            options={{
              headerTitle: {
                DAILY: intlTokens.DailyRoutines,
                WEEKLY: intlTokens.WeeklyRoutines,
                MONTHLY: intlTokens.MonthlyRoutines,
              }[props.route.params.freq],
              headerLeft: () => (
                <HeaderButton type="CLOSE" onPress={props.navigation.goBack} />
              ),
            }}
          />
          <Stack.Screen
            name="TeamScheduleHistoryScreenDetail"
            component={TeamScheduleHistoryDetailScreen}
            initialParams={props.route.params}
            options={{
              headerTitle: "",
            }}
          />
        </Stack.Group>
      ) : (
        <Stack.Screen
          name="TeamScheduleHistoryScreen"
          component={TeamScheduleHistoryScreenCombined}
          initialParams={props.route.params}
          options={{
            headerTitle: "",
            headerLeft: () => (
              <HeaderButton type="CLOSE" onPress={props.navigation.goBack} />
            ),
          }}
        />
      )}
    </Stack.Navigator>
  );
};

function TeamScheduleHistoryDetailScreen(props: {
  navigation: UserLoggedInNavigatorNavigationProp<"TeamScheduleHistory">;
  route: RouteProp<ParamList, "TeamScheduleHistoryScreenDetail">;
}) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fk) => (
        <TeamScheduleHistoryDetail
          teamId={props.route.params.teamId}
          fetchKey={fk}
          id={props.route.params.id}
        />
      )}
    </LazyQueryNetworkBoundrary>
  );
}
